// Vuex imageBoard store module.

let client = ''

const state = {
  currentImage : '',
  imageSize    : 100,
  imageList    : [
    'https://s3-us-west-1.amazonaws.com/riot-developer-portal/docs/map11.png',
    '/static/img/SR-full-map.png',
    '/static/img/NB-full-map.jpg'
  ],
  visible: true
}

const getters = {
  imageList    : state => state.imageList,
  imageSize    : state => state.imageSize,
  visible      : state => state.visible,
  currentImage : state => state.currentImage
}

const socketsOfMutation = {
  SOCKET_image_joinRoom (state, {image, size}) {
    state.currentImage = image
    state.imageSize    = size
  },
  SOCKET_image_imageChange (state, data) {
    state.currentImage = data
  },
  SOCKET_image_sizeChange (state, data) {
    state.imageSize = data
  },
  SOCKET_image_connect (state, socket) {
    client = socket
  }
}

const mutations = {
  addImageToList (state, image) {
    state.imageList.push(image)
  },
  initializeList (state, defaultImageList) {
    state.imageList = [
      'https://s3-us-west-1.amazonaws.com/riot-developer-portal/docs/map11.png',
      '/static/img/SR-full-map.png',
      '/static/img/NB-full-map.jpg'
    ]
  },
  clearImageList (state) {
    state.imageList = []
  },
  sizeChange (state, data) {
    state.imageSize = data
  },
  toggleVisible (state) {
    state.visible = !state.visible
  },
  ...socketsOfMutation
}

const actions = {
  addImageToList ({commit}, image) {
    commit('addImageToList', image)
  },
  initializeList ({commit}, defaultImageList) {
    commit('initializeList', defaultImageList)
  },
  clearImageList ({commit}) {
    commit('clearImageList')
  },
  changeCurrentImage ({commit}, image) {
    commit('SOCKET_image_imageChange', image)
    // client.binary(true).emit('imageChange', image)
  },
  changeImageSize ({commit}, size) {
    commit('sizeChange', size)
  },
  emitImageSize ({commit}, size) {
    commit('SOCKET_image_sizeChange')
    // client.emit('sizeChange', size)
  },
  toggleVisible ({commit}) {
    commit('toggleVisible')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/image/store/index.js